import React,{useEffect} from 'react'
import { motion, useAnimation } from 'framer-motion'
import {useInView} from 'react-intersection-observer'
import MyPhoto from './IMG_5962.jpg'

const textVariants = {
    hidden: {
        x:'5vw',
        opacity:0
    },
    visible: {
        x:0,
        opacity: 1,
        transition: {
            duration: 0.5,
            ease:'easeOut',
            delay:1
        }
    }
}

function About() {
    const controls = useAnimation()
    const { ref, inView } = useInView({
        triggerOnce:true
    })
    
    useEffect(() => {
        if (inView) {
           controls.start('visible')
        } if (!inView) {
           controls.start('hidden')   
       }
    },[controls,inView])
    return (
        <div className="photo-container">
            <div>
                <img
                    className="my-photo"
                    src={MyPhoto} alt="myphoto"
                />
            </div>
            <motion.div
                ref={ref}
                variants={textVariants}
                initial="hidden"
                animate={controls}
                className="about">
                <div className="about-heading">
                    Something about me
                </div>
                hello there , my name is Priyanshu Bhardwaj
                and welcome to my website.
                i am from india.
                currently pursuing my Bachelors in
                Information Technology.
                i am a self-learning web developer and love to create front-end designs and
                cross-platform mobile applications<br/>
                i am excited to <span style={{
                    color:'#834bff'
                }}>collaborate</span> with you 
            </motion.div>
        </div>
    )
}

export default About
